import React, { memo } from "react";
import ReactDOM from "react-dom";
import { PlainButton } from "@culturehq/components";

const PhotoFace = memo(({ boundingBox, face, onTagStart }) => {
  const style = {
    left: boundingBox.left + boundingBox.width * parseFloat(face.left, 10),
    top: boundingBox.top + boundingBox.height * parseFloat(face.top, 10),
    width: boundingBox.width * parseFloat(face.width, 10),
    height: boundingBox.height * parseFloat(face.height, 10)
  };

  const onClick = event => {
    event.stopPropagation();

    onTagStart({
      clientX: boundingBox.containerLeft + style.left,
      clientY: boundingBox.containerTop + style.top + style.height + 10,
      uuid: face.uuid
    });
  };

  return (
    <PlainButton
      className="chq-photo-tag chq-photo-tag-active"
      onClick={onClick}
      style={style}
    />
  );
});

const PhotoFaces = ({ boundingBox, containerRef, onTagStart, photo }) => ReactDOM.createPortal(
  <>
    {photo.faces.map(face => (
      <PhotoFace key={face.uuid} boundingBox={boundingBox} face={face} onTagStart={onTagStart} />
    ))}
  </>,
  containerRef.current
);

export default PhotoFaces;
